if (document.querySelector(".mt-slideshow__container") != null) {
  document.querySelectorAll(".mt-slideshow__container").forEach((container) => {
    const carousel = container.querySelector(".mt-slideshow__wrapper");
    const slides = container.querySelector(".mt-slideshow__items");
    const slideItems = container.querySelectorAll(".mt-slideshow__item");
    const prevBtn = container.querySelector(".mt-slideshow-control.prev");
    const nextBtn = container.querySelector(".mt-slideshow-control.next");
    const dotsContainer = container.querySelector(".mt-slideshow-dots");
    let progressBar = container.querySelector(".mt-slideshow-dot.active .mt-slideshow-progress-bar");

    // 触摸相关变量
    let touchStartX, touchStartY, touchEndX, isScrolling;

    slides.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isScrolling = undefined;
    }, { passive: true });

    slides.addEventListener('touchmove', function(e) {
        if (isScrolling === undefined) {
            const xDiff = Math.abs(e.touches[0].clientX - touchStartX);
            const yDiff = Math.abs(e.touches[0].clientY - touchStartY);

            isScrolling = xDiff > yDiff;
        }
        if (isScrolling) {
            e.preventDefault();
        }
    }, { passive: false });

    slides.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].clientX;
        const deltaX = touchEndX - touchStartX;
        const threshold = 50;
        if (isScrolling && Math.abs(deltaX) > threshold) {
            if (deltaX > 0) {
                stopAutoSlide();
                prevSlide();
                startAutoSlide();
            } else if (deltaX < 0) {
                stopAutoSlide();
                nextSlide();
                startAutoSlide();
            }
        }
    }, { passive: true });
    

    let currentIndex = 0;
    const slideCount = slideItems.length;
    const intervalTime = 5000; // 10秒切换一次
    let slideInterval;
    let progressInterval;
    let progress = 0;  
    let startTime;

    // 更新轮播点状态
    function updateDots(index) {
      const dots = document.querySelectorAll(".mt-slideshow-dot");
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
      progressBar = container.querySelector(".mt-slideshow-dot.active .mt-slideshow-progress-bar");
    }

    // 更新进度条 - 修复版本
    function updateProgressBar() {
      progress = 0;
      startTime = Date.now();
      
      if (progressBar) {
        progressBar.style.width = "0%";
      }

      clearInterval(progressInterval);

      progressInterval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        progress = Math.min((elapsed / intervalTime) * 100, 100);
        
        if (progressBar) {
          progressBar.style.width = `${progress}%`;
        }

        if (progress >= 100) {
          clearInterval(progressInterval);
          // 确保进度条完全填满后再切换
          setTimeout(() => {
            nextSlide();
          }, 50); // 给进度条一个短暂的显示时间
        }
      }, 50); // 更频繁的更新，让进度条更平滑
    }

    // 切换到指定幻灯片
    function goToSlide(index) {
      currentIndex = (index + slideCount) % slideCount;
      // 每次滑动时动态获取当前宽度，解决页面缩放时滑动不准确的问题
      const currentSlideWidth = carousel.offsetWidth;
      slides.scrollLeft = currentIndex * currentSlideWidth;
      updateDots(currentIndex);
      updateProgressBar();
    }

    // 下一张幻灯片
    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    // 上一张幻灯片
    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    // 开始自动轮播
    function startAutoSlide() {
      // 移除旧的定时器，避免冲突
      clearInterval(slideInterval);
      updateProgressBar();
    }

    // 停止自动轮播
    function stopAutoSlide() {
      clearInterval(slideInterval);
      clearInterval(progressInterval);
    }

    // 初始化
    startAutoSlide();

    // 事件监听
    prevBtn.addEventListener("click", () => {
      stopAutoSlide();
      prevSlide();
      startAutoSlide();
    });

    nextBtn.addEventListener("click", () => {
      stopAutoSlide();
      nextSlide();
      startAutoSlide();
    });

    carousel.addEventListener("mouseenter", stopAutoSlide);
    carousel.addEventListener("mouseleave", startAutoSlide);
  });
}
